var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-table',{staticClass:"tableclass",attrs:{"columns":_vm.columns,"data-source":_vm.getData,"rowKey":(r) => r.Key,"locale":{ emptyText: 'Butiken saknar kontaktpersoner' },"pagination":false,"bordered":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }